import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const submitBuyerForecastOverrideDataSlice = createApi(`SubmitBuyerForecastOverrideDataSlice`,"POST");

const SubmitBuyerForecastOverrideDataSlice = createSlice({
  name: 'SubmitBuyerForecastOverrideDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitBuyerForecastOverrideDataSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitBuyerForecastOverrideDataSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(submitBuyerForecastOverrideDataSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SubmitBuyerForecastOverrideDataSlice.reducer;